<template>
  <v-container fluid class="px-0">
    <div class="employee-page">
      <v-row>
        <v-col cols="12" md="12">
          <v-card class="user-card ma-1" min-height="282">
            <v-card-text class="pa-5 pt-9 fill-height">
              <v-row no-gutters class="fill-height">
                <v-col
                  cols="12"
                  md="2"
                  class="d-flex justify-center align-center flex-column"
                >
                  <div class="avatar-wrapper">
                    <v-img
                      class="user-avatar"
                      contain
                      v-bind:src="initvalue.employeeimage"
                    ></v-img>
                  </div>
                  <v-chip small class="mr-2 mt-4 mb-4 mb-sm-0" color="primary">
                    {{ initvalue.employeestatus }}</v-chip
                  >
                </v-col>
                <v-col>
                  <v-row>
                    <p class="user-name greyMedium--text font-weight-regular">
                      {{ initvalue.employeename }}
                    </p>
                    <v-spacer></v-spacer>
                    <v-btn @click="$router.replace({ name: 'EmployeeList' })" color="primary" text>
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="5"
                      class="
                        pl-0 pl-sm-4
                        d-flex
                        flex-column
                        align-center align-sm-start
                      "
                    >
                      <p class="user-work ma-0"><b>EMPLOYEE</b></p>
                      <p class="two-line">{{ initvalue.employeename }}</p>
                      <p class="two-line">{{ initvalue.employeeaddress }}</p>
                      <p class="two-line">{{ initvalue.employeephone }}</p>
                      <p class="two-line">{{ initvalue.employeemobile }}</p>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      class="
                        pl-0 pl-sm-4
                        d-flex
                        flex-column
                        align-center align-sm-start
                      "
                    >
                      <p class="user-work ma-0"><b>BIRTHDATE</b></p>
                      <p class="two-line">
                        {{
                          initvalue.employeebirthdate != undefined
                            ? new Date(initvalue.employeebirthdate).toLocaleString(
                                "en-SG",
                                {
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                }
                              )
                            : ""
                        }}
                      </p>
                      <p style="margin-bottom: 5px"></p>
                      <p class="user-work ma-0"><b>START</b></p>
                      <p class="two-line">
                        {{
                          initvalue.employeestartdate != undefined
                            ? new Date(initvalue.employeestartdate).toLocaleString(
                                "en-SG",
                                {
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                }
                              )
                            : ""
                        }}
                      </p>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      class="
                        pl-0 pl-sm-4
                        d-flex
                        flex-column
                        align-center align-sm-start
                      "
                    >
                      <p class="user-work ma-0"><b>AMOUNT</b></p>
                      <p class="two-line">
                        {{
                          initvalue.employeetotal != undefined
                            ? initvalue.employeetotal.toLocaleString("en-SG")
                            : ""
                        }}
                      </p>
                      <p class="two-line">{{ initvalue.employeepayterms }}</p>
                      <p style="margin-bottom: 5px"></p>
                      <p class="user-work ma-0"><b>NOTE</b></p>
                      <p class="two-line">{{ initvalue.employeenote }}</p>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      ref="filesTab"
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-files'"
                    >
                      Files
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-images'"
                    >
                      Images
                    </v-tab>

                    <v-tab-item
                      :key="2"
                      :value="'tab-files'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            :headers="fileHeaders"
                            :items="files"
                            :items-per-page="100"
                            class="elevation-0"
                          >
                            <template v-slot:item.filetype="{ item }">
                              <a
                                v-if="item.filetype == 'pdf'"
                                :href="item.fileurl"
                                style="text-decoration: none !important"
                              >
                                <v-icon size="50" color="primary">
                                  mdi-file-pdf-box
                                </v-icon></a
                              >
                            </template>
                            <template v-slot:item.filesize="{ item }">
                              {{ (item.filesize / 1000).toFixed(0) + " KB" }}
                            </template>
                            <template v-slot:item.createdAt="{ item }">
                              {{
                                new Date(item.createdAt).toLocaleString(
                                  "en-SG",
                                  {
                                    year: "numeric",
                                    month: "numeric",
                                    day: "numeric",
                                  }
                                )
                              }}
                            </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="previewFile(item)"
                          >
                            <v-icon>mdi-text-box-search</v-icon>
                          </v-btn>
                        </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row> </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import config from "@/config";
import { mapActions } from "vuex";

export default {
  name: "Profile",

  data() {
    return {
      config,
      initvalue: {},
      transactions: [],
      files: [],
      selectedTab: "1",
      headers: [
        { text: "Image", value: "itemimage" },
        { text: "Name", value: "itemname" },
        { text: "Foc", value: "itemfoc" },
        { text: "Qty", value: "itemquantity" },
        { text: "Prc", value: "itemprice" },
        { text: "Amount", value: "itemamount" },
      ],
      fileHeaders: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      arrayEvents: null,
      apexLoading: false,
      apexArea1: {
        options: {
          chart: {
            id: "apexAreaFirst",
            sparkline: {
              enabled: true,
            },
          },
          colors: [config.light.secondary],
          fill: {
            type: "solid",
            opacity: 0.3,
          },
          stroke: {
            width: 2,
            curve: "smooth",
          },
        },
        series: [
          {
            data: [50, 56, 52, 51, 52, 55, 53],
          },
        ],
      },
      picker: new Date().toISOString().substr(0, 10),
    };
  },
  methods: {
    ...mapActions("File", ["getEmployeeFiles", "getDownloadFile"]),
    previewFile(item){
      let params = Object.assign({}, this.initvalue);
      params.fileurl = item.fileurl;
      params.isFromEmployee = true;
      this.$router.push({ name: "FilePreview", params: params })
    },
  },
  async mounted() {
    this.initvalue = this.$route.params;
    console.log("HERE", this.initvalue)
    
    if (!this.initvalue._id) this.$router.push({ name: "EmployeeList" });

    this.files = await this.getEmployeeFiles(this.initvalue._id);
    if(this.initvalue.isFromFiles==true) {this.$refs.filesTab.$el.click()}
  },
};
</script>

<style src="./View.scss" lang="scss"/>
